import React, {Component} from 'react';
import {Tabs, Modal,} from 'antd-mobile';
import "./style.less";
export default class InsuranceModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs:[
                {title:"产品介绍"},
                {title:"投保须知"},
            ],
        };
    }

    render(){
        return(
            <Modal
                popup
                visible={this.props.modal}
                className="insuranceModal"
                transparent
                closable
                animationType="slide-up"
                onClose={this.props.onClose}
            >
                <Tabs tabs={this.state.tabs} animated={false} useOnPan={false}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '250px', backgroundColor: '#fff' }}>
                        {this.props.data.length > 0 ? this.props.data[this.props.index].chanpin : null}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '250px', backgroundColor: '#fff' }}>
                        {this.props.data.length > 0 ? this.props.data[this.props.index].xuzhi : null}
                    </div>
                </Tabs>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/InsuranceModal/index.js